import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconArrowDown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-arrow_down_svg__stroke",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("path", {
        d: "M44.63574,15.20508,26,32.59766,7.36426,15.20508a1.9996,1.9996,0,0,0-2.72852,2.92383l20,18.666a1.9985,1.9985,0,0,0,2.72852,0l20-18.666a1.9996,1.9996,0,0,0-2.72852-2.92383Z"
      }));
    }
  }));
}
export default SvgIconArrowDown;